import { render } from "./CashRegisterWidget.vue?vue&type=template&id=4d5ae47d"
import script from "./CashRegisterWidget.vue?vue&type=script&lang=js"
export * from "./CashRegisterWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__